import { render, staticRenderFns } from "./AdminStatusPage.vue?vue&type=template&id=456d5794&"
import script from "./AdminStatusPage.vue?vue&type=script&lang=js&"
export * from "./AdminStatusPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports